"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const bodyParts_1 = require("../../bodyParts");
const BodyParts_1 = require("../shared/BodyParts");
const male_back_png_1 = __importDefault(require("./male-back.png"));
const MaleImage_1 = __importDefault(require("./MaleImage"));
const paths = {
    [bodyParts_1.BodyPartsBack.LeftUpperSkull]: {
        d: `M362.759,17.13c-0.2,0-0.4,0-0.6,0c-27.3,0-58.5,32-58,52.7c0.1,4.5,0.8,14.8,1.3,23.3c15.4,1.9,36.7,2.9,58,2.9v-78.9
    C363.259,17.13,362.959,17.13,362.759,17.13z`,
        "aria-label": "Back left upper skull",
    },
    [bodyParts_1.BodyPartsBack.RightUpperSkull]: {
        d: `M363.459,17.13v78.8c21.3,0,42.5-0.9,58-2.8c0.9-8.3,1.7-15.6,2-20.6C424.859,51.13,395.359,18.03,363.459,17.13z`,
        "aria-label": "Back right upper skull",
    },
    [bodyParts_1.BodyPartsBack.LeftLowerSkull]: {
        d: `M305.459,93.13c0.4,6.3,0.8,11.6,1,13c0.2,2.4,4.3,32,7.5,49.6c1,5.7,1.9,10.1,2.6,12c13.8,1.2,30.4,1.7,47,1.7v-73.5
    C342.159,95.93,320.959,95.03,305.459,93.13z`,
        "aria-label": "Back left lower skull",
    },
    [bodyParts_1.BodyPartsBack.RightLowerSkull]: {
        d: `M363.459,95.93v73.5c16.7,0,33.4-0.6,47.4-1.8c0.2-1.7,0.4-2.9,0.6-3.6c0.2-0.7,0.8-3.6,1.5-7.9
    c2.2-13.6,6.1-41.8,8.5-63.1C406.059,95.03,384.759,95.93,363.459,95.93z`,
        "aria-label": "Back right lower skull",
    },
    [bodyParts_1.BodyPartsBack.LeftNeck]: {
        d: `M316.959,168.63c1.6,2,2.9,28.4,0.5,31.5c-7.8,10.1-31.5,20.8-49.2,27.5c10.6-2.9,52.4-3.8,94.5-3.4l0,0c0.2,0,0.5,0,0.7,0
    v-54.8c-16.6,0-33.2-0.6-47-1.7C316.659,168.13,316.859,168.43,316.959,168.63z`,
        "aria-label": "Back left neck",
    },
    [bodyParts_1.BodyPartsBack.RightNeck]: {
        d: `M459.959,228.13c-28-9.5-49-27.3-50-29.5c-0.8-1.8-0.1-22.2,0.9-30.9c-13.9,1.2-30.6,1.8-47.4,1.8v54.8
    C407.159,224.53,450.959,226.23,459.959,228.13z`,
        "aria-label": "Back right neck",
    },
    [bodyParts_1.BodyPartsBack.LeftShoulder]: {
        d: `M310.159,224.53c-20.1,0.5-36,1.5-42,3.1c-8.1,3.1-15,5.3-18.5,6.2c-8.3,2.2-41.9,9.4-53.5,19.5c-17.2,15-26,35-27.5,62.8
    c-0.1,2.7-0.2,5.4-0.3,8.1c28.6,3.4,82.6,5.4,142.2,6.2C306.159,295.13,305.959,259.83,310.159,224.53z`,
        "aria-label": "Back left shoulder",
    },
    [bodyParts_1.BodyPartsBack.LeftArm]: {
        d: `M223.959,375.83c-2.9-16.4-6.4-32.5-10.3-48.2c-18.3-0.9-33.8-2.1-45.3-3.4c-0.2,10.2,0.3,19.5,0.3,26.4h0.1
    c-6.8,10.7-18.2,33.8-20,44s-4.5,20-7.2,27.8c-4,34.5,10.7,40.8,26.1,46.4c8.7,3.2,16.3,3.2,22.9,0.2c4.8-2.2,9.1-6,12.9-11.3
    c0.9-1.2,1.7-2.6,2.5-4c1.1-2.2,2.2-4.3,3.2-6.2c0.2-0.4,0.4-0.8,0.7-1.3c4.2-8.6,15.8-33.3,16.6-36c0.7-2,1.5-3.7,2.3-4.4
    C227.359,395.73,225.759,385.73,223.959,375.83z`,
        "aria-label": "Back left arm",
    },
    [bodyParts_1.BodyPartsBack.LeftElbow]: {
        d: `M167.559,468.83c-15.4-5.7-30.1-11.9-26.1-46.4c-2.8,7.8-1.8,15.2-6.5,23.5s-0.8,6.5-9.8,20
    c-4.2,6.3-9,20.1-13.2,35.5c-1.3,4.6-2.5,9.4-3.6,14.1c3.4-5.9,6.6-22.6,50.4-11c10.7,2.8,31.9,11.2,26.9,27.5
    c2.7-7.8,4.7-15.2,6.3-21.6c2.5-10.4,3.7-18,4-19.9c0.5-4.3,0.8-7.3,1.5-9.3s2.2-9.8,2.3-13.2c0.1-2.4,3.1-8.5,6-14.3
    C196.759,469.43,184.059,474.93,167.559,468.83z`,
        "aria-label": "Back left elbow",
    },
    [bodyParts_1.BodyPartsBack.LeftForearm]: {
        d: `M158.859,504.43c-43.8-11.6-47,5.1-50.4,11c-3.1,13.1-5.6,25.9-6.7,35.2c-2.2,17.5-8.4,42.6-11.8,56.1
    c-0.9,6,6.2,9.7,17.6,14.5c11,4.7,23.7,4,26.3,0.2c10.1-17.1,26.8-37.5,39.9-61.5c4.9-9,8.9-18.7,12.1-27.9
    C190.659,515.63,169.559,507.23,158.859,504.43z`,
        "aria-label": "Back left forearm",
    },
    [bodyParts_1.BodyPartsBack.LeftWrist]: {
        d: `M107.459,621.13c-11.4-4.8-18.4-8.5-17.6-14.5c-1.2,4.8-2.1,8.2-2.2,9.1c-0.7,3.5-4.2,10.2-6.2,18.3
    c-0.4,1.7-2.8,3.5-5.5,4.5c3.7-0.7,44.6,18.4,45.2,20.5c-1-4-1.2-8,7-27c1.5-3.4,3.4-7,5.6-10.7
    C131.159,625.23,118.459,625.83,107.459,621.13z`,
        "aria-label": "Back left wrist",
    },
    [bodyParts_1.BodyPartsBack.LeftHand]: {
        d: `M75.959,638.63c-3.2,1.1-14.2,7-17.8,8.5s-5.8,6.5-10.2,9s-8.3,6-9,8.8s-5.5,4.3-5.5,7.3s2,5.3,6.9,6
    s12.6-8,14.1-9.5s2.5,0.5,1.8,2.3s-5.7,15-6.8,19.8c-1.2,4.8-3.8,17-4.5,21s-3,21-3.3,24s-3.3,15,1.2,18.3s7.8-2.3,9.8-7.7
    s1.5-11.8,2.7-14.5s4.3-19,6.3-22.5s2.8,1.2,1.7,4.2c-1.1,3-3.8,16.2-3.8,18.3s-1.8,14-2.5,18s-1.3,14,0,18.2s7.2,1.7,9-0.5
    s3.7-11.2,4.5-16.5s1-14.2,2.5-20s3.6-16.3,5.5-19.2s3.8,0.3,3.3,2.5s-2.3,9.5-4,16.3s-1.5,14.5-3,21.3s-3.2,12.3,0,15.8
    s6.5,0.8,8.5-1.7s4.3-13.3,5.7-21.8s4.7-21.2,5.8-25.2c1.2-4,3.5-7.8,5.3-7.5s-0.2,6-1,9.2s-5,20.7-5.2,26.3s2.5,7.8,5.7,6.5
    s4.3-6,5-8.8s2.7-8.7,3.2-12s4.2-16.2,6.2-20.3c2-4.2,2.8-9.3,6.7-27.3c3.8-18,1.5-22.3,0.5-26.3
    C120.559,657.03,79.659,637.93,75.959,638.63z`,
        "aria-label": "Back left hand",
    },
    [bodyParts_1.BodyPartsBack.RightShoulder]: {
        d: `M416.659,330.43c59.8-0.8,113.9-2.8,142.4-6.2c0.1-17-1.7-36.5-12.9-54.7c-16.9-27.5-57.7-31.8-85.7-41
    c-0.1-0.1-0.3-0.2-0.4-0.3c-5.2-1.1-21.6-2.1-42.9-2.8C421.259,260.33,421.059,295.33,416.659,330.43z`,
        "aria-label": "Back right shoulder",
    },
    [bodyParts_1.BodyPartsBack.RightArm]: {
        d: `M587.959,428.63c-2-7.6-4.8-13-8-28.8c-3.7-18.3-14-40-21.2-51.6c-0.1-0.1-0.3-0.2-0.4-0.3c0.1-6.9,0.6-15,0.7-23.7
    c-11.6,1.4-27.3,2.5-45.9,3.5c-3.9,15.7-7.3,31.8-10.3,48.2c-1.7,9.7-3.3,19.4-4.7,29.3l0,0l0,0c1.2-0.1,2.7,2.9,4,5.7
    c0.8,1.8,9.4,20.7,15.8,34.8c2.1,4.6,4,8.7,5.3,11.5c0.2,0.3,0.5,0.6,0.7,1c3.5,4.8,7.5,8.3,12,10.5c7,3.4,15.2,3.6,24.3,0.2
    C574.759,463.53,589.359,457.73,587.959,428.63z`,
        "aria-label": "Back right arm",
    },
    [bodyParts_1.BodyPartsBack.RightElbow]: {
        d: `M568.959,504.43c39.1-10.4,46.7,1.8,50.3,8.8c-0.2-1.4-0.4-2.7-0.6-3.8c-2.8-17.8-17.8-47-19.5-49.8
    s-8.2-16.5-10.2-26.8c-0.3-1.5-0.6-2.9-1-4.2c1.5,29.1-13.2,34.9-27.7,40.2c-15.3,5.6-27.9,1.4-37-11.7c0.8,1.7,1.4,2.9,1.7,3.5
    c2.2,4.2,2.2,4.8,2.2,7.8s2.8,14.2,4.1,19.5c1.2,5,0.1,15.9,7.6,38.9C541.259,514.53,559.959,506.83,568.959,504.43z`,
        "aria-label": "Back right elbow",
    },
    [bodyParts_1.BodyPartsBack.RightForearm]: {
        d: `M620.359,621.13c8.9-3.7,15.1-6.8,17-10.8c-2-5.8-4-12.8-5.4-20.3c-3-15.9-9.6-57.1-12.7-76.9
    c-3.6-7-11.1-19.1-50.3-8.8c-9.1,2.4-27.7,10.2-30.3,22.4c0.5,1.4,0.9,2.8,1.4,4.3c9,26,30,55.2,45.5,79.5c3,4.6,5.5,8.9,7.6,12.7
    C599.259,625.23,611.559,624.83,620.359,621.13z`,
        "aria-label": "Back right forearm",
    },
    [bodyParts_1.BodyPartsBack.RightWrist]: {
        d: `M648.159,637.93c-3.5-0.5-4-8.2-5.2-12.2c-0.7-2.2-3.1-7.8-5.6-15.2c-1.9,4-8.1,7-17,10.8
    c-8.7,3.7-21.1,4.1-27.1,2.2c9.1,16.2,11.4,25.4,12.4,29.1c0.5,2.1,0.6,3.6,0.5,4.9c8.1-4.7,34.2-16.3,43.6-19.1
    C649.159,638.03,648.659,637.93,648.159,637.93z`,
        "aria-label": "Back right wrist",
    },
    [bodyParts_1.BodyPartsBack.RightHand]: {
        d: `M675.859,654.43c-2.3-1-7.9-8.1-12.7-10.1c-4.1-1.7-9.8-5-13.5-6.1c-9.3,2.8-35.4,14.5-43.6,19.1
    c-0.2,1.6-0.9,3.1-1.8,5.3c-1.7,4-0.7,16.2,0.3,19.5s4.2,22.3,5.8,26s3,8.2,3.7,10.5s7.7,32,10.2,34.3s5.7,1.8,7-0.5
    s0.5-7.5,0-10.8s-1.7-9.8-2-12.5s-2.3-10.5-3.3-14.2s1.3-3.7,3-1.5s3.3,8.7,4.2,11.8s3.5,16.2,4.3,20.7s2.8,17.7,5.8,20.8
    s5.7,3.3,8.2,1s1.2-7.3,0.8-10.2s-2.5-19.2-2.8-23s-3.8-14.3-4.7-20.5s2.7-1.8,3-0.5s4.2,14.8,4.7,18.3s3,15.7,3.5,22.7
    s3.7,13,4.8,14.5s6,2.2,7.5,0s1.2-5.7,1-9.3s-1.5-22.2-1.5-25.7s-4.5-19.8-5-23.5s1.3-1.8,2-0.2c0.7,1.7,5,19.2,5.8,22.8
    s1.2,7.3,1.8,12s3.8,9,6.3,10.3s5.5-1.2,6.5-3.8s-1.5-15.2-1.8-23.3s-1.5-11.3-2.2-14s-3-18.2-3.8-22.5s-6.7-19-7.7-21.8
    s4.2,0.5,5.7,2.8s7.5,5.5,10.5,5.3s5.7-1.7,6-5.3s-3.8-4.5-5.8-9.8C684.759,659.23,678.159,655.43,675.859,654.43z`,
        "aria-label": "Back right hand",
    },
    [bodyParts_1.BodyPartsBack.Cervical]: {
        d: `M416.659,330.43c4.4-35,4.6-70.1,0.5-105.1c-16.2-0.6-35.3-1-54.3-1.1h-0.3c-18.4-0.2-36.7-0.1-52.4,0.3
    c-4.2,35.3-4,70.6,0.5,105.9C345.259,330.83,381.959,330.83,416.659,330.43z`,
        "aria-label": "Back cervical",
    },
    [bodyParts_1.BodyPartsBack.UpperSpinalThoracic]: {
        d: `M325.459,330.53c0.6,7.1,1.2,14.2,1.6,21.2c1.1,15.7,1.8,31.4,2.3,47.1c22.7,1.4,45.4,1.4,68.1,0
    c0.5-15.7,1.2-31.4,2.3-47.1c0.5-7.1,1-14.1,1.6-21.2C376.359,330.73,350.559,330.73,325.459,330.53z`,
        "aria-label": "Back upper spinal thoracic",
    },
    [bodyParts_1.BodyPartsBack.LowerSpinalThoracic]: {
        d: `M396.959,421.63c0.1-7.6,0.3-15.2,0.5-22.8c-22.7,1.4-45.4,1.4-68.1,0c0.2,7.6,0.4,15.2,0.5,22.8
    c0.2,18.9,0.1,37.7-0.5,56.5c22.7,1.9,45.4,1.9,68.1,0C396.959,459.33,396.759,440.53,396.959,421.63z`,
        "aria-label": "Back lower spinal thoracic",
    },
    [bodyParts_1.BodyPartsBack.LeftThoracic]: {
        d: `M329.959,421.63c-0.1-7.6-0.3-15.2-0.5-22.8c-0.5-15.7-1.2-31.4-2.3-47.1c-0.5-7.1-1-14.1-1.6-21.2c-5,0-10-0.1-14.9-0.2
    c-35.7-0.5-69.4-1.4-96.8-2.8c3.9,15.7,7.3,31.8,10.3,48.2c1.8,9.9,3.4,19.9,4.8,29.9c0.3-0.3,0.6-0.4,0.8-0.4
    c1,0.2,1.4,3.6,1.8,6.1c0.4,2.6,4.2,16.8,9.2,23c0.8,1,1.6,2.3,2.3,3.8c3.5,7.1,6.7,19.1,9.7,26.2c25.6,7,51.2,11.6,76.9,13.7
    C329.959,459.33,330.159,440.53,329.959,421.63z`,
        "aria-label": "Back left thoracic",
    },
    [bodyParts_1.BodyPartsBack.RightThoracic]: {
        d: `M416.359,330.43c-4.9,0.1-9.9,0.1-14.9,0.2c-0.6,7.1-1.2,14.2-1.6,21.2c-1.1,15.7-1.8,31.4-2.3,47.1
    c-0.2,7.6-0.4,15.2-0.5,22.8c-0.2,18.9-0.1,37.7,0.5,56.5c25.9-2.2,51.7-6.8,77.6-13.9c2.5-5.5,5.4-12.6,6.4-15.7
    c1.1-3.8,2.1-7.1,3.4-10c0.4-0.9,0.9-1.8,1.4-2.7c2.2-3.5,7.8-18.1,8.7-21.1c0.8-3,2.2-9.4,3.3-9.5c1.4-9.9,3-19.6,4.7-29.3
    c2.9-16.4,6.3-32.5,10.3-48.2C485.759,329.03,452.059,329.93,416.359,330.43z`,
        "aria-label": "Back right thoracic",
    },
    [bodyParts_1.BodyPartsBack.UpperSpinalLumbar]: {
        d: `M401.659,547.83c-1-11-1.8-22-2.5-33c-0.7-12.2-1.3-24.4-1.7-36.7c-22.7,1.9-45.4,1.9-68.1,0c-0.4,12.3-1,24.5-1.7,36.8
    c-0.7,11-1.5,22-2.5,33c-0.7,8.4-1.6,16.8-2.5,25.2c12.6,1.6,26.4,2.6,41,2.6c14.4,0,28-0.9,40.5-2.5
    C403.259,564.73,402.459,556.23,401.659,547.83z`,
        "aria-label": "Back upper spinal lumbar",
    },
    [bodyParts_1.BodyPartsBack.LowerSpinalLumbar]: {
        d: `M322.759,573.03c-2.4,21.9-5.4,43.6-8.9,65.2c4.4,2.1,8.4,4.4,12,6.9l0,0c25.2-6.3,50.4-6.3,75.5,0l0,0
    c3.6-2.5,7.5-4.7,11.7-6.8c-3.6-21.6-6.5-43.4-8.9-65.3c-12.4,1.6-26.1,2.5-40.5,2.5C349.159,575.53,335.259,574.63,322.759,573.03
    z`,
        "aria-label": "Back lower spinal lumbar",
    },
    [bodyParts_1.BodyPartsBack.LeftLumbar]: {
        d: `M252.559,464.33c0.4,1,0.8,1.8,1.2,2.6c0.1,0.2,0.3,0.3,0.5,0.5c3.8,7.5,6.2,18.9,8.2,37.2c1.5,14-0.5,24.9-2,31.9
    c-0.5,2.4-1,4.4-1.2,5.9c-1,5.8-0.2,23.9,1.2,28c1.4,3.9,3.6,9-0.4,15.8l0,0l0,0c-0.2,0.3-0.4,0.6-0.6,0.9
    c-3.5,5.3-7,22.1-9.2,37.6c27.2,1,47.9,5.9,63.6,13.5c4.9-29.9,8.7-60,11.4-90.4c2-23.1,3.4-46.4,4.2-69.7
    C303.759,475.93,278.159,471.33,252.559,464.33z`,
        "aria-label": "Back left lumbar",
    },
    [bodyParts_1.BodyPartsBack.RightLumbar]: {
        d: `M477.159,619.23c-1.6-13.7-6.1-25.6-8.5-31.7c-0.2-0.5-0.4-1-0.6-1.4c0-0.1-0.1-0.2-0.2-0.3c-0.4-1.1-0.8-1.8-0.9-2.2
    c-0.8-2.3-1.2-6.2-0.3-8.2c0.8-2,2.7-12.8,2.8-19c0.1-3.4-1.1-12.1-2.3-20.1c-1-6.5-2-12.5-2.4-14.7c-1-4.8,1.7-28.5,2.3-33.3
    c0.8-4.9,3.1-14.7,4.4-16.9c0.4-0.6,1.2-2.4,2.3-4.6c0.1-0.1,0.1-0.1,0.2-0.2c0.4-0.8,0.7-1.6,1.1-2.5
    c-25.9,7.1-51.7,11.8-77.6,13.9c0.7,23.4,2.1,46.6,4.2,69.7c2.7,30.5,6.5,60.7,11.4,90.6c15.9-7.8,36.9-12.8,64.6-13.7
    C477.559,622.83,477.359,621.03,477.159,619.23z`,
        "aria-label": "Back right lumbar",
    },
    [bodyParts_1.BodyPartsBack.Sacrum]: {
        d: `M401.359,645.23C401.359,645.13,401.359,645.13,401.359,645.23c-25.2-6.3-50.4-6.3-75.5,0l0,0
    c-3.4,37.2-3.7,74.5-1.1,111.7c9-2,18.1-6.9,26.9-15.7c2.8-2.9,6.8-8.9,7.8-11.6c0.8-2.3,1.7-3,3.3-3.2v-0.1c0.1,0,0.3,0,0.4,0
    c0.2,0,0.4-0.1,0.6-0.1c0.1,0,0.2,0,0.3,0c2.2,0.1,3.6,1.2,3.9,2.9c0.4,1.8,3.8,8.5,7.3,11.3c9.2,9.7,18.3,15.4,27.1,18.1
    C405.059,720.73,404.759,682.93,401.359,645.23z`,
        "aria-label": "Back sacrum",
    },
    [bodyParts_1.BodyPartsBack.LeftButtock]: {
        d: `M247.959,651.13c0.5,12.2-2.5,24-4,32.5c0,19,7.3,25.1,15.3,37.1c15.3,23.2,39.9,41.8,65.5,36.1
    c-2.6-37.2-2.3-74.5,1.1-111.7c-16.7-11.5-40.8-19.2-75.6-20.5C248.659,635.73,247.759,646.03,247.959,651.13z`,
        "aria-label": "Back left buttock",
    },
    [bodyParts_1.BodyPartsBack.LeftHamstring]: {
        d: `M259.259,720.73c-8-12.1-15.3-18.1-15.3-37.1c-1.5,8.5-8.2,43-9.8,54s-3,14.5-7.2,46.8s-1.2,76,2.8,93.5
    s12.7,36.2,15.2,49.2c14.2,23.2,32,27.7,48.3,28.7c17.7,1.1,33.4-2.9,40.7-15.4c1.7-5.8,6-44.5,8.2-58s9.5-61.3,10.5-78.7
    s1-35,0.2-41s-1.6-16.3-1-21.7C317.359,775.03,279.959,752.03,259.259,720.73z`,
        "aria-label": "Back left hamstring",
    },
    [bodyParts_1.BodyPartsBack.LeftKnee]: {
        d: `M293.159,955.83c-16.2-1-34-5.5-48.3-28.7c2.5,13,3.2,32.2,4.2,53.5c0.7,13.9-0.1,29.7-1.2,42.4
    c2.6-20.9,19.1-19.1,35.6-17.5c16.6,1.7,33.3,3.3,35.7,9.9c-1.2-5.5,0.7-11.2,3-16s3.2-17.8,4-28.8s5.8-24.3,7.5-30.2
    C326.659,952.93,310.859,956.93,293.159,955.83z`,
        "aria-label": "Back left knee",
    },
    [bodyParts_1.BodyPartsBack.LeftCalf]: {
        d: `M283.659,1005.63c-16.5-1.6-33.1-3.4-35.6,17.5c-0.6,6.7-1.2,12.7-1.8,17.1c-1.8,12.8-5,46-2.5,60
    s8.8,70.5,9,91.8c2.4,11.6,18.5,15.4,31.6,15.9c13.2,0.5,23.3-2.3,25.6-16.1c1.5-12.2,2.9-25.1,3.1-31.6c0.3-11.3,8.3-24,12.8-37.3
    s0.5-46.7-1.2-65.5s-4.2-36.3-5.3-41.8C316.859,1008.83,300.259,1007.23,283.659,1005.63z`,
        "aria-label": "Back left calf",
    },
    [bodyParts_1.BodyPartsBack.LeftAnkle]: {
        d: `M284.259,1207.83c-13.1-0.5-29.2-4.4-31.6-15.9c0.2,21.2,4.1,51.5,4.2,58.1s-1.2,26.8-1,28.6
    c0.2,1.8,0.2,3.8-0.9,3.8c6.1,14.4,4.3,25.2,3.6,34.4c-0.4,5.1,0.2,9.5,1.3,14.2c10.5-13.5,48-20.2,48.2-7.5
    c-0.2-6.2-1.2-13.5-2.1-20.5c-1.5-12.8,1.8-27.3,2.2-31.2s-4.5-18.5-5.8-25.5s2.2-19.2,4.2-31.3c0.9-5.2,2.1-14.1,3.2-23.3
    C307.559,1205.53,297.459,1208.33,284.259,1207.83z`,
        "aria-label": "Back left ankle",
    },
    [bodyParts_1.BodyPartsBack.LeftAchilles]: {
        d: `M259.959,1330.93c2.3,2.2,12.7,9.2,23.2,11.7s19.2-1.5,23-7.2c1.7-2.6,2.2-6.9,2.1-12
    C307.959,1310.83,270.459,1317.43,259.959,1330.93z`,
        "aria-label": "Back left achilles",
    },
    [bodyParts_1.BodyPartsBack.LeftForefoot]: {
        d: `M258.659,1316.83c0.7-9.2,2.4-20-3.6-34.4c-1.1,0-2.9,1.4-3.1,2.6s-2.4,0.6-4,0.1s-6.6,4.5-6.8,5.1
    s-0.2,1.2-2.2,1.1s-5.8,3.1-5.9,4.1s-1.2,1.8-2.9,2s-4.2,3-5.2,5.3s0.8,4.8,1.7,9.2s6.7,9.3,18.8,12.2c12.1,2.9,12.2,4.7,14.5,6.8
    C258.859,1326.33,258.259,1321.93,258.659,1316.83z`,
        "aria-label": "Left forefoot",
    },
    [bodyParts_1.BodyPartsBack.RightButtock]: {
        d: `M402.359,758.43c27.6,8.5,52.5-12.7,67.3-36.5c8.5-13.7,14.1-14.9,14.1-38.4c-1.4-8.3-3.3-18-3.9-21.6
    c-1.1-5.7-0.6-20.8-2.1-37.2c-35.2,1.2-59.5,8.9-76.4,20.5C404.759,682.93,405.059,720.73,402.359,758.43z`,
        "aria-label": "Back right buttock",
    },
    [bodyParts_1.BodyPartsBack.RightHamstring]: {
        d: `M375.359,740.43c0.8,5.8,0.1,10.2-1.2,28.7s3.2,73.2,6.5,86.8s7,38,8.8,56.2c1.1,11.4,3.4,23.1,5.6,32.4
    c8.4,9.2,24.1,12.3,39.7,11.3c15.3-0.9,32.9-5,46.8-24.9c0.9-6,1.7-9.6,2-10.8c0.8-3,10.8-28,13.5-41.2s4.2-43.1,5.2-58.1
    s-4.5-54-5.8-61.7s-3.8-29.7-5.2-35.8s-4.3-21.7-4.8-25.7c-0.2-1.7-1.3-7.5-2.5-14c0,23.5-5.6,24.7-14.1,38.4
    C450.159,753.43,413.059,780.33,375.359,740.43z`,
        "aria-label": "Back right hamstring",
    },
    [bodyParts_1.BodyPartsBack.RightKnee]: {
        d: `M434.659,955.83c-15.6,1-31.2-2.1-39.7-11.3c1.3,5.6,2.6,10.3,3.7,13.6c2.8,8.8,2.2,34.2,5.5,40.5
    c2.6,4.9,3.7,9.3,3.5,15.2c6-4.7,22.4-6.8,36.5-8.2c13.7-1.4,29.4,1.3,35.9,14c-1-13.9-1.8-29.9-1.6-46.8c0.1-18.8,1.7-33,3-41.9
    C467.559,950.83,449.959,954.93,434.659,955.83z`,
        "aria-label": "Back right knee",
    },
    [bodyParts_1.BodyPartsBack.RightCalf]: {
        d: `M444.159,1005.63c-14.2,1.4-30.5,3.5-36.5,8.2c-0.1,1.6-0.2,3.3-0.5,5.1c-1.2,8.8-7,65.3-7.5,84.8
    s7.5,36,10.5,40s3.8,15.5,4,21.8c0.1,3.2,1.8,16.7,3.8,30.9c5.6,7.7,15.9,11.9,25.6,11.5c11.8-0.5,25.9-3.6,30.5-12.6
    c0.1-3.3,0.3-6.4,0.4-9.1c0.8-13,4.8-46.8,7.5-74s3-44.8,1-62.2c-0.9-8.1-2-18.4-2.9-30.2
    C473.559,1006.93,457.859,1004.23,444.159,1005.63z`,
        "aria-label": "Back right calf",
    },
    [bodyParts_1.BodyPartsBack.RightAnkle]: {
        d: `M443.559,1207.83c-9.7,0.4-19.9-3.8-25.6-11.5c1.9,13.8,4.2,28.2,5.7,34.3c3,12.5,1,17.8-1.8,26.7
    s-2.3,14.3-1.3,22s0.7,17.5,0.5,24.5c-0.1,4.1-2.1,11.3-2.6,18c5.4-8.7,37.8-2.7,48.5,9c0.5-0.5,1-0.9,1.5-1.4
    c0.8-4.1,1.1-8.5,0.8-12.7c-1-13.2-2-21.1,3-33.8c-0.1-0.1-0.2-0.1-0.3-0.2c-2.2-1.5-1.7-12.7-1.7-21.7s1.2-24.2,2.2-32
    c0.8-6.1,1.1-21.4,1.6-33.9C469.459,1204.23,455.259,1207.33,443.559,1207.83z`,
        "aria-label": "Back right ankle",
    },
    [bodyParts_1.BodyPartsBack.RightAchilles]: {
        d: `M418.359,1321.83c-0.4,4.8,0,9.4,2.5,12.3c6.6,7.9,13.3,10.3,26.7,7.2c9.4-2.2,15.7-7.1,19.4-10.4
    C456.159,1319.13,423.759,1313.13,418.359,1321.83z`,
        "aria-label": "Back right achilles",
    },
    [bodyParts_1.BodyPartsBack.RightForefoot]: {
        d: `M469.159,1316.83c0.3,4.2,0,8.7-0.8,12.7c0.8-0.8,1.4-1.4,1.8-1.7c2.2-1.8,16-5.7,21.5-7.5s7.3-7.2,7.7-10.2
    s0.5-2.7,1.8-5.8s-5.2-7.5-6-7.5s-2,0-2-1.5s-3.7-4.3-5.2-4.3s-3-1-3.5-2.5s-6.7-3.8-8.8-3.5c-2.1,0.3-1.7-0.6-3.5-1.9
    C467.159,1295.63,468.159,1303.63,469.159,1316.83z`,
        "aria-label": "Right forefoot",
    },
};
const BackMaleBodyParts = (props) => {
    return react_1.default.createElement(BodyParts_1.BodyParts, Object.assign({ image: react_1.default.createElement(MaleImage_1.default, { href: male_back_png_1.default }), paths: paths }, props));
};
exports.default = BackMaleBodyParts;
//# sourceMappingURL=BackMaleBodyParts.js.map